<ng-container>
  <ng-template #refH1><ng-content select=".title"></ng-content></ng-template>
  @if (useFullScreen) {
    <mat-toolbar color="primary" fxLayout="row" class="mat-elevation-z1" [class.fixedHeader]="fixedHeader">
      <div fxFlex>
        <ng-container [ngTemplateOutlet]="refH1"></ng-container>
      </div>
      <div>
        <button mat-icon-button mat-dialog-close tabindex="-1"><mat-icon>close</mat-icon></button>
      </div>
    </mat-toolbar>
  }
  @if (!useFullScreen) {
    <div class="dialog-header" fxLayout="row">
      <div fxFlex class="dialog-header-title">
        <ng-container [ngTemplateOutlet]="refH1"></ng-container>
      </div>
      <div>
        <button mat-icon-button mat-dialog-close tabindex="-1"><mat-icon>close</mat-icon></button>
      </div>
    </div>
  }
  <mat-dialog-content [class.mobile]="useFullScreen" [class.fixedHeader]="fixedHeader">
    <ng-content></ng-content>
  </mat-dialog-content>
</ng-container>

